import $ from 'jquery'
import { ref } from 'vue'

export default {
    name: 'manage-anamnese',
    components: {},
    props: {
        consultation_id: Number,
        evolution_id: Number,
        user_id: Number,
        info_user: Object,
        group_id: Number,
        data_to_be_deleted: Object,
        list_atcd_anamneses: Array
    },
    data() {
        return {
            save_loading: false,
            is_loading: true,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'debut', 'signe_associe', 'signe_negatif', 'traitement_avt_admission', 
                'bilan_avt_admission', 'evolution',
            ],

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            // transcript: ref(''),
            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
            can_show_micro: [],
            recognition_err_msg: ''
        }
    },

    watch: {
        list_atcd_anamneses() {
            this.atcd_allergo_p = {
                v_model: []
            } 
            this.initFields()
            this.permission_is_denied = false
            this.is_error = false
        }
    },

    computed: {

    },

    mounted() {
        for (let i = 0; i <= 5; i++) {
            this.can_show_micro[i] = true
        }
    },

    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.list_atcd_anamneses.length > 0) {
                    v = this.list_atcd_anamneses[index]['field_content']
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        saveAnamnese() {
            this.permission_is_denied = false
            this.is_error = false
            this.save_loading = true

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                data_type: 'histoire_de_la_maladie',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                if (response.success) {
                    this.successToast('Anamnèse ajoutée avec succès')
                    this.$emit("emitAnamnese")

                    this.$refs.anamnese_mdl.click()
                } else {
                    if (response.code == 500) {
                        this.is_error = true
                    } else if (response.code == 403) {
                        this.permission_is_denied = true
                    }
                    console.log("Erreur iconnue");
                }
                this.stopRecording()

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerGroupMotif(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteAntecedent', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Anamnèse supprimée avec succès')
                    this.$emit("emitAnamnese")

                    this.$refs.del_grp_anamnese.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        recordSpeech(input_selector, index) {
            this.recognition_err_msg = ''
            let area_focus = document.getElementById(input_selector+this.evolution_id)
            area_focus.focus()

            // Show the microphone for the current index and hide others
            this.can_show_micro[index] = true
            for (let i = 0; i <= 5; i++) {
                if (i != index) {
                    this.can_show_micro[i] = false
                }
            }

            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = "La conversion Audio-Text n'est pas supportée par votre navigateur ! "+
                    "Merci d'utiliser un navigateur moderne comme Google Chrome ou Microsoft Edge."
                return
            }
            this.is_listening = true

            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'

            this.recognition.onresult = (evt) => {
                let interimTranscript = ''

                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.transcript = evt.results[i][0].transcript
                    if (evt.results[i].isFinal) {
                        this.atcd_allergo_p.v_model[index].value += this.transcript
                    } else {
                        interimTranscript += evt.results[i][0].transcript
                    }
                }

                console.log("Final : ",interimTranscript)
            }

            this.recognition.onerror = (evt) => {
                this.recognition_err_msg = "Une erreur est survenue lors de la conversion Audio-Text. "+
                    "Merci de vérifier votre connexion internet !"
                console.log("Speech recognition error: ",evt);
            }

            this.recognition.start()
        },

        stopRecording() {
            this.recognition_err_msg = ''
            this.recognition.stop();
            this.is_listening = false;
        
            // Restore all microphone icons to visible
            for (let i = 0; i <= 5; i++) {
                this.can_show_micro[i] = true;
            }
        
            // Optional: Clear the transcript if you want to start fresh next time
            this.transcript = ""; 
        }
    }
}


